
/////////////////////////
// ===== Sliders ===== //
/////////////////////////

$(document).ready(function(){
  $('.testimonal-slider-container').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    pageDots: true
  });
  
  
  $('.custom-feature-collection-slider').flickity({
    cellAlign: 'left',
    pageDots: false,
    wrapAround: true,
//     autoPlay: true,
    lazyLoad: 1,
     prevNextButtons: false
  });
  
  
  
  $('.custom-best-seller-container').flickity({
    cellAlign: 'left',
    pageDots: false,
    wrapAround: true,
//     autoPlay: true,
    lazyLoad: 1,
    prevNextButtons: false
  });
  
  //Homepage Banner
  
//     $('.homepage-banner-carousel').flickity({
//     	fullscreen: true,
//           lazyLoad: 1,
//           pageDots: false,
//       	  prevNextButtons: false,
//           wrapAround: false,
//           autoPlay: false,
//           autoPlay: 5000 
//     });
  
   $('.product-description h2').each(function(index){ 
     if(index>=1){
       $(this).addClass('accordion');
   	   $(this.nextElementSibling)
        .nextUntil("h2")
        .addBack()
        .wrapAll('<div class="panel" />');
     } 
	});
  
  var acc = $(".product-description .accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
  this.classList.toggle("active");
  var panel = this.nextElementSibling;
  if (panel.style.maxHeight){
  panel.style.maxHeight = null;
  } else {
  panel.style.maxHeight = panel.scrollHeight + "px";
  }
  });
  }
  
  
  $(".product-description #insta-feed").remove();
                                 
});


 $(function() {
        $('.flickity-slider .product-card').matchHeight(); 
       
    });

///////////////////////////////
// =====End of Sliders ===== //
///////////////////////////////


////////////////////////////
// ===== Accordions ===== //
////////////////////////////
/*

var acc = document.getElementsByClassName("product-description");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}
*/

